export default __webpack_public_path__ + "static/media/bower.a3e13b47.svg";